import React from 'react'
import {Lang} from 'yougile-lang'
import {StickerColor, stickerColors, StickerIcon} from 'yougile-model'
import {AnyColor} from '@components/common/base/design-system'
import {Icon} from '@components/common/base/icon'
import {BgOpacityContainer} from '@components/common/bg-opacity-container/bg-opacity-container'
import {StringStickerSettingsInput} from '@components/common/text-input/string-sticker-settings-input'
import {
  TwColorsContainer,
  TwIcon,
  TwSaveButton
} from '@components/sticker/my-stickers/sticker-editor/string-state-edit/containers'
import {noPropagate} from '@containers/hooks'
import {cn} from '@containers/html-utils'

interface EditStickerStringStateProps {
  value: string
  onChange: (title: string) => void
  onEnterSave: () => void
  cancel: () => void
  onSave: () => void
  onClickOnColor: (color: StickerColor) => void
  inputMaxWidth?: string
  selectedColor?: StickerColor
  icon?: StickerIcon
  colorsClassName?: string
}

const stickerColorsStates = stickerColors.filter(
  color => color !== 'sticker-white' && color !== 'sticker-transparent'
)

export const StickerStringStateEditor = React.forwardRef(
  (
    props: EditStickerStringStateProps,
    ref: React.MutableRefObject<HTMLElement>
  ) => {
    const {
      value,
      selectedColor,
      icon,
      onChange,
      onEnterSave,
      cancel,
      onSave,
      onClickOnColor,
      inputMaxWidth,
      colorsClassName
    } = props

    return (
      <div className="relative">
        <div className="flex items-center">
          <StringStickerSettingsInput
            innerRef={ref}
            autoFocus
            value={value}
            onChange={onChange}
            onEnter={onEnterSave}
            onEscape={cancel}
            maxWidth={inputMaxWidth}
            placeholder={Lang.msg.stickerStatePlaceholder}
          />
          <TwSaveButton onClick={onSave}>{Lang.msg.save}</TwSaveButton>
        </div>
        <TwColorsContainer
          className={colorsClassName}
          onMouseDown={noPropagate}
        >
          {stickerColorsStates.map(color => {
            const iconColor: AnyColor = `icon-${color}`

            return (
              <div className="relative w-20 h-20" key={color}>
                <BgOpacityContainer
                  bgOpacityClassName={cn(
                    selectedColor === color ? 'opacity-20' : 'opacity-0'
                  )}
                  bgColorClassName="bg-interactive-old rounded-full"
                  bgPosition="-top-4 -left-4"
                  className="w-28 h-28"
                >
                  <TwIcon
                    className={`items-center justify-center bg-${iconColor}`}
                    onClick={() => onClickOnColor(color)}
                  >
                    {icon && <Icon icon={icon} color={iconColor} />}
                  </TwIcon>
                </BgOpacityContainer>
              </div>
            )
          })}
        </TwColorsContainer>
      </div>
    )
  }
)
